// extracted by mini-css-extract-plugin
export default {"parkingSlot":"parking-slot_parkingSlot__LxMCf","busy":"parking-slot_busy__HSB-D","disabled":"parking-slot_disabled__tCUiU"};